import React, { useRef, useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { fetchdata, viewdocdata, fetchviewdata, fetchviewDoc, SAVEDATA, ApplyData, ReApplyData, fetchChatData, addmsgdata, fetchSaveData } from '../reduxactions/organizationactions/OrgViewAppActions';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { useSelector } from 'react-redux';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import { InputSwitch, InputSwitchChangeEvent } from 'primereact/inputswitch';
import { RootState } from '../reducers';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { InputTextarea } from 'primereact/inputtextarea';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Message } from 'primereact/message';

export const OrgViewApplication = () => {

  const uid = window.sessionStorage.getItem('uid');
  const usertype = window.sessionStorage.getItem('usertype');
  const [globalFilter, setGlobalFilter] = useState('');

  const location = useLocation();

  const [queryParams, setQueryParams] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setQueryParams(params.get("application_id") as any);
  }, [location]);
  const { application_id } = useParams();
  console.log('Row ID:', application_id);
  const dispatch = useDispatch()

  const data = useSelector((state: RootState) => state.orgapplicationview.data);
  const viewdata = useSelector((state: RootState) => state.orgapplicationview.viewdata);
  const docdata = useSelector((state: RootState) => state.orgapplicationview.docdata);
  console.log(docdata)
  const docview = useSelector((state: RootState) => state.orgdoc.docview);

  const datasave = useSelector((state: RootState) => state.orgapplicationview.datasave);
  const dataapply = useSelector((state: RootState) => state.orgapplicationview.dataapply);
  const datareapply = useSelector((state: RootState) => state.orgapplicationview.datareapply);
  const chatdata = useSelector((state: RootState) => state.orgapplicationview.chatdata);
  const msgdata = useSelector((state: RootState) => state.orgapplicationview.msgdata);
  const [showShare, setShowShare] = useState(false);
  const [rowClick, setRowClick] = useState<boolean>(true);
  //const [selectedCategories, setSelectedCategories] = useState<any>([]);

  const [selectedIds, setSelectedIds] = useState<number[]>([]);




  //To get data
  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchdata(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchDataViewAsync = async () => {
    try {
      await dispatch(fetchviewdata(uid, application_id) as any);
    } catch (error) {
      console.error('Error fetching data', error)
    }
  }
  // To get data
  useEffectOnce(() => {
    fetchDataAsync();
    fetchDataViewAsync();
    Fetchdocs();

    fetchChatDataAsync();


  }, [dispatch]);
  const [allattachments, setAttachments] = useState(false);
  const [description, setDescription] = useState('');
  //  const [description, setDescription] = useState(response.description);
  const [acceptfield, setfield] = useState(false);

  const cancelfield = () => {
    setAttachments(false);
  }
  const cancelfields = () => {
    setfield(false);
  }

  const viewupload = (rowData: any) => {
    console.log("RowData:", rowData)
    assignData.current = { did: rowData.DocID }

    setfield(true);
    fetchDataAsyncdialog()
  };
  const assignData = useRef({ did: '' })

  const fetchDataAsyncdialog = async () => {
    try {
      const { did } = assignData.current;
      console.log("DocID", did)
      await dispatch(viewdocdata(did) as any);
    } catch (error) {
      console.error('Error deleting data:', error);
    }
  }

  //To assign data 

  const Fetchdocs = async () => {

    try {
      await dispatch(fetchviewDoc(application_id) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const Attachmentslist = () => {

    setAttachments(true);
    fetchDataAsync();
  };
  const datas = data

  // const [selectedCategories, setSelectedCategories] = useState(datas);
  const [selectedCategories, setSelectedCategories] = useState<any[]>([]);


  const onCategoryChange = (e: CheckboxChangeEvent) => {
    let _selectedCategories = [...selectedCategories];
    console.log('_selectedCategories', _selectedCategories)


    if (e.checked)
      _selectedCategories.push(e.value);
    else
      _selectedCategories = _selectedCategories.filter(response => response.DocID !== e.value.DocID);

    setSelectedCategories(_selectedCategories);
    if (_selectedCategories.length > 0) {
      setShowShare(true);
      console.log("Setshowshare", setShowShare)
    } else {
      setShowShare(false);
    }

  };

  // const getSelected = async () => {
  //   await dispatch(fetchSaveData(application_id, selectedCategories, uid) as any);
  //   toast2.current.show({ severity: 'success', summary: 'Success', life: 3000 })

  //   setAttachments(false);
  //   // setTimeout(() => {
  //   //   window.location.reload();
  //   // }, 3000);

  // };

  const getSelected = async () => {

    // ✅ Extract only DocIDs
    const selectedDocIds = selectedCategories.map((item: any) => item.DocID);

    console.log("Application ID:", application_id);
    console.log("Selected Doc IDs:", selectedDocIds);

    await dispatch(fetchSaveData(application_id, selectedDocIds, uid) as any);

    toast2.current.show({
      severity: 'success',
      summary: 'Success',
      life: 3000
    });

    setAttachments(false);

    // ✅ Refresh attachment list
    Fetchdocs();
  };




  const [selectedRows, setSelectedRows] = useState([]);
  const onSelectionChange = (e: any) => {
    setSelectedRows(e.value);
  };
  const toast = useRef(datasave);
  const saveApplication = async (response: any) => {

    try {
      await dispatch(SAVEDATA(uid, application_id, description) as any);
      toast.current.show({ severity: 'success', summary: 'Success', detail: datasave, life: 3000 })

    } catch (error) {
      console.error('Error applying :', error);
    }

    fetchDataAsync();

  };
  const toast3 = useRef(dataapply);
  const navigate = useNavigate();
  const Apply = async (response: any) => {
    try {
      await dispatch(ApplyData(uid, application_id, description) as any);
      toast3.current.show({ severity: 'success', summary: 'Success', detail: dataapply, life: 3000 })
      const url = `/oorgapplications`;
      navigate(url);
    } catch (error) {
      console.error('Error applying :', error);
    }

    fetchDataAsync();
    //   setTimeout(() => {
    //     window.location.reload();
    // }, 3000);

  };
  const toast1 = useRef(datareapply);
  const Reapply = async (response: any) => {
    try {
      await dispatch(ReApplyData(uid, application_id, description) as any);
      toast1.current.show({ severity: 'success', summary: 'Success', detail: datareapply, life: 3000 })
      const url = `/oorgapplications/`;
      navigate(url);
    } catch (error) {
      console.error('Error applying :', error);
    }

    fetchDataAsync();
  };
  const fetchChatDataAsync = async () => {
    try {
      await dispatch(fetchChatData(uid, usertype, application_id) as any);
    } catch (error) {
      console.error('Error fetching data', error)
    }
  };
  const toast2 = useRef(msgdata);
  const [message, setMessage] = useState<string>('');
  const AddsMessage = async () => {
    try {
      await dispatch(addmsgdata(uid, message, application_id) as any);
      toast2.current.show({ severity: 'success', summary: 'Sent Successfully', detail: msgdata, life: 3000 })
      setMessage('');
    } catch (error) {
      console.error('Error fetching data', error)
    }
    fetchChatDataAsync();
  }
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/view-org-applications.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };
  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="content-wrapper">
            <section className="app-page-header">
              <div>
                <h1 className="app-page-title">View Application</h1>
              </div>
              <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                Help for this Page
                <i className="pi pi-question-circle"></i>
              </a>
            </section>
            {viewdata.map((response: any) =>
              <section className="content">
                <Card title="">
                  <Panel header="Fundmanager Information">
                    <div className="grid">

                      <div className="col-12 md:col-12 lg:col-6">
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Fund Manager Name  :</strong>
                          <p className="text-muted">{response.nameofthehead}</p>
                        </div>


                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Website   :</strong>
                          <p className="text-muted">{response.website_url}</p>
                        </div>



                      </div>

                    </div>
                  </Panel>
                  <Panel header="Organization Information">
                    <div className="grid">

                      <div className="col-12 md:col-12 lg:col-6">
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Organization Name :</strong>
                          <p className="text-muted">{response.nameoftheorg}</p>
                        </div>


                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Organization Head :</strong>
                          <p className="text-muted">{response.nameofthehead}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Designation :</strong>
                          <p className="text-muted">{response.designation}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>License No:</strong>
                          <p className="text-muted">{response.licenseno}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>License Expired Date :</strong>
                          <p className="text-muted">{response.license_expdate}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Organization Type :</strong>
                          <p className="text-muted">{response.suborg_type}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Application Expired Date :</strong>
                          <p className="text-muted">{response.exp_date}</p>
                        </div>

                      </div>
                      <div className="col-12 md:col-12 lg:col-6">
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Email :</strong>
                          <p className="text-muted">{response.email}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Address :</strong>
                          <p className="text-muted">{response.address}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Contact No :</strong>
                          <p className="text-muted">{response.mobile}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Country :</strong>
                          <p className="text-muted">{response.CountryName}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Paypal Account :</strong>
                          <p className="text-muted">{response.paypal_account}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Status :</strong>
                          <p className="text-muted">{response.status}</p>
                        </div>
                      </div>
                    </div>
                  </Panel>
                </Card>
                <Card title="" >
                  <Panel header="Description">
                    <div className="grid">
                      <div className="col-10">
                        <InputTextarea
                          id="description"
                          value={response.description}
                          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setDescription(e.target.value)}
                          rows={20} // Adjust rows and cols as needed
                          cols={80}

                        />



                      </div>
                      <div className="col-10"></div>
                      <div className="col-2">
                        <Button
                          className="btn btn-primary"
                          label="Save"
                          style={{ float: 'left' }}
                          onClick={() => saveApplication(response)}

                        />
                        <Toast ref={toast} >
                          <Message severity="success" content={datasave} />
                        </Toast>
                      </div>

                    </div>
                  </Panel>
                </Card>
              </section>

            )}
            <section className="content">
              <Card title="">
                <Panel header="Attachments">

                  <div className="grid">
                    <div className="col-10"></div>
                    <div className="col-2">

                      <Button label="Attachments" className="btn btn-primary" onClick={() => Attachmentslist()} />

                    </div>
                    <div className="col-12">
                      <div className="card card-primary">
                        <div className="card flex flex-wrap justify-content">
                          <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                          </span>
                        </div>
                        <DataTable value={docdata} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                          <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                          <Column field="doc_name" sortable header="Attachment Name"></Column>
                          <Column field="expiry_date" sortable header="Expiry Date"></Column>
                          <Column header="Operation" body={(rowData) => (
                            <>

                              <Button icon="pi pi-eye" tooltip="View" className='mr-4' onClick={() => viewupload(rowData)} style={{ backgroundColor: 'white', color: 'blue', borderRadius: '30px', width: '2rem', height: '2rem' }} />





                            </>
                          )} />




                        </DataTable>

                      </div>
                    </div>
                  </div>
                </Panel>
              </Card>
              <div className="card direct-chat direct-chat-primary">
                <Panel header="Chat">
                  {chatdata.map((response: any) =>

                    <div className="grid">
                      <div className="col-12">
                        <Splitter >
                          <SplitterPanel className="flex align-items-center justify-content-left">{response.name}, {response.date} </SplitterPanel>
                          <SplitterPanel className="flex align-items-center justify-content-left">{response.msg} </SplitterPanel>
                        </Splitter>
                      </div>
                    </div>

                  )}
                  <div className="card-footer">
                    <div className="grid">
                      <div className='col-11'>
                        <InputText value={message} placeholder="Type Message ..." className="w-full mb-10" onChange={(e) => setMessage(e.target.value)} />
                      </div>
                      <span className="input-group-btn">
                        <div className='col-1'>
                          <Button severity="info" icon="pi pi-send" rounded outlined onClick={AddsMessage} />
                        </div>
                      </span>
                    </div>
                  </div>
                </Panel>
              </div>
              <br></br>
              <div className='grid'>
                <div className='col-9'></div>
                <div className='col-3'>
                  {viewdata.map((response: any) => (
                    response.status === 'New' && (
                      <Button className='mr-1' severity="success" label="Apply" rounded onClick={() => Apply(response)} />
                    )

                  ))}
                  {viewdata.map((response: any) => (
                    response.status === 'Reject' && (
                      <Button className='mr-1' severity="success" label="Re-Apply" rounded onClick={() => Reapply(response)} />
                    )

                  ))}
                  {viewdata.map((response: any) => (
                    response.status === 'Expired' && (
                      <Button className='mr-1' severity="success" label="Re-Apply" rounded onClick={() => Reapply(response)} />
                    )

                  ))}
                </div>
              </div>
            </section>
            <Dialog header="Attanchments" breakpoints={{ '960px': '75vw', '641px': '100vw' }} visible={allattachments} style={{ width: '60vw' }} onHide={cancelfield} >
              <div className="col-12">
                <div className="card card-primary">
                  <div className="card flex flex-wrap justify-content">
                    <span className="p-input-icon-left">
                      <i className="pi pi-search" />
                      <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                    </span>
                  </div>

                  <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} selection={selectedCategories} onSelectionChange={(e: any) => setSelectedCategories(e.value)} selectionMode="checkbox">
                    <Column selectionMode='multiple' header="Select" headerStyle={{ width: '1.5rem' }}></Column>
                    <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                    <Column field="doc_name" sortable header="Attachment Name"></Column>
                    <Column field="CreteDate" sortable header="Expiry Date"></Column></DataTable>
                  {/* <DataTable
                      value={data}
                      stripedRows
                      paginator
                      rows={5}
                      rowsPerPageOptions={[5, 10, 25, 50]}
                      tableStyle={{ minWidth: '50rem' }}
                      globalFilter={globalFilter}
                      selectionMode="multiple"
                      selection={selectedRows}
                      onSelectionChange={(e) => setSelectedRows(e.value)}
                    >
                      <Column                header="Select" 
                  body={(rowData) => (
                              <td>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <div key={rowData.DocID} className="flex align-items-center">
                                    <Checkbox inputId={rowData.DocID} name="category" value={rowData} onChange={onCategoryChange} checked={selectedCategories.some((item: any) => item.DocID === rowData.DocID)} />
                                  </div>
                                </div>
                              </td>
                            )} />

                      <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                      <Column field="doc_name" sortable header="Attachment Name"></Column>
                      <Column field="CreteDate" sortable header="Expiry Date"></Column>
                     
                    </DataTable> */}

                </div>
              </div>
              <div className="modal-footer">
                <Button label="Close" className="p-button-raised p-button-secondary" onClick={cancelfield} />
                <Button label="Save changes" className="p-button-raised" style={{ float: 'right' }} onClick={getSelected} name="update" />
              </div>
            </Dialog>
            <Dialog header="View" style={{ width: '50vw' }} visible={acceptfield} onHide={cancelfields}>
              <div className="modal-header">
                <Button icon="pi pi-times" className="p-button-text" />
              </div>
              <div className="modal-body">
                {docview.map((response: any, index: number) =>
                  <div key={index}>
                    {response.filetype === 'photo' && <img src={response.displayfile} alt="Doc" width="100%" height="auto" />}
                    {response.filetype !== 'photo' &&
                      <img src={response.displayfile} alt="Doc" width="100%" height="auto" />
                    }

                    {response.filetype === 'pdf' && (
                      <a href={response.displayfile} target="_blank" rel="noopener noreferrer">
                        Open PDF in New Tab
                      </a>
                    )}
                  </div>
                )}
              </div>
            </Dialog>
            <Toast ref={toast2} >
              <Message content={msgdata} />
            </Toast>
            <Toast ref={toast1} >
              <Message severity="success" content={datareapply} />
            </Toast>
            <Toast ref={toast3} >
              <Message severity="success" content={dataapply} />
            </Toast>
          </div>
        </div>
      </div>
    </div >
  )
}
export default OrgViewApplication
